// #region Dependencias
import styled from 'styled-components'
// #endregion

// #region Estilos
const StyledFlexItem = styled.div`
  align-items: ${({ alignItems = 'center' }) => alignItems};
  display: flex;
  flex-basis: calc(${({ flexBasis }) => flexBasis}% - 1rem);
  flex-direction: ${({ flexDirection = 'row' }) => flexDirection};
  justify-content: ${({ justifyContent = 'center' }) => justifyContent};
  padding: 1rem;
  width: 100%;
`
// #endregion

/**
 * Componente para renderizar un item en un contenedor flex.
 *
 * @class
 * @example <FlexItem>...</FlexItem>
 *
 * @param {Object} props - Propiedades del componente.
 * @param {string} [props.alignItems="center"] - Atributo align items.
 * @param {number} [props.flexBasis=null] - Atributo 'justify-content'.
 * @param {number} [props.flexDirection='row'] - Atributo 'flex-direction'.
 * @param {string} [props.justifyContent="center"] - Atributo justify content.
 * @param {React.ReactNode} props.children - Contenido que será renderizado dentro del componente.
 */
const FlexItem = ({ children, ...props }) => {
  return <StyledFlexItem {...props}>{children}</StyledFlexItem>
}

export default FlexItem
